export default __webpack_public_path__ + "images/c0e28ed6f111ddc5fdfef115cda447ce.svg";